import {
  getAuth,
  signInWithEmailLink as firebaseSignInWithEmailLink,
} from "firebase/auth";

const signInWithEmailLink = (email: string) => {
  const auth = getAuth();

  return firebaseSignInWithEmailLink(auth, email, window.location.href);
};

export default signInWithEmailLink;
